import segmentProps from '../lib/segmentProps';

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_registration_document_upload_attempted',
            props: {
                ...segmentProps,
                id_file_type: '#context.idFileType',
                id_type: '#context.idType',
                upload_status: '#context.uploadStatus',
            },
        },
    },
};
